import React from 'react'
import "../App.css"
import quelldheader from "../Assets/Onboardingimages/quelldheader.png";
import { useNavigate } from 'react-router-dom';


export const HeaderSection = () => {

    const navigate = useNavigate()

    const handleClick = ()=>{
        navigate('/')

    }
    
  return (
    <div className='header-section'>
        <div className='header-image' >
            <img  src={quelldheader} style={{width:'76px',cursor:'pointer'}}  onClick={handleClick} />
        </div>
     </div>
  )
}
